export const DEFAULT_TOKENS_LIST = {
  current: {
    name: 'Compound',
    logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/compound-interface.svg',
    keywords: ['compound', 'defi'],
    timestamp: '2021-05-27T20:37:00.000+00:00',
    tokens: [
      {
        chainId: 97,
        address: '0x510601cb8Db1fD794DCE6186078b27A5e2944Ad6',
        name: 'MDT',
        symbol: 'MDT',
        decimals: 18,
        logoURI: 'https://assets.coingecko.com/coins/images/12409/thumb/amp-200x200.png?1599625397',
      },
      {
        chainId: 80002,
        address: '0x47B1A0ad58C1BE485448E4d81843361Ba84089a3',
        name: 'MDT',
        symbol: 'MDT',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 97,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 43113,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 11155420,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 59141,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 44787,
        address: '0x47B1A0ad58C1BE485448E4d81843361Ba84089a3',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 84532,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 168587773,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 1313161555,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 534351,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 1287,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 11155111,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 80002,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 421614,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 4002,
        address: '0x9BED7e1B07be88894bBf599b50E8189C55b0a888',
        name: 'Chief Finance Coin',
        symbol: 'CFNC',
        decimals: 18,
        logoURI: '',
      },
      {
        chainId: 421614,
        address: '0xb1D4538B4571d411F07960EF2838Ce337FE1E80E',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 11155420,
        address: '0xE4aB69C077896252FAFBD49EFD26B5D171A32410',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 59141,
        address: '0xF64E6E064a71B45514691D397ad4204972cD6508',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 44787,
        address: '0x32E08557B14FaD8908025619797221281D439071',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 84532,
        address: '0x9014dAE23DfB0059A0c2bc7E6503334F213A8036',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 168587773,
        address: '0x9014dAE23DfB0059A0c2bc7E6503334F213A8036',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 534351,
        address: '0x231d45b53C905c3d6201318156BDC725c9c3B9B1',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 1287,
        address: '0xF771707F18751a644B4066d6818cbe11B96Ea9a3',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 4002,
        address: '0xfaFedb041c0DD4fA2Dc0d87a6B0979Ee6FA7af5F',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 80002,
        address: '0x0Fd9e8d3aF1aaee056EB9e802c3A762a667b1904',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 11155111,
        address: '0x779877A7B0D9E8603169DdbD7836e478b4624789',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        chainId: 1,
        address: '0xE41d2489571d322189246DaFA5ebDe1F4699F498',
        name: '0x Protocol Token',
        symbol: 'ZRX',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_ZRX.svg',
      },
      {
        name: 'Uniswap',
        address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
        symbol: 'UNI',
        decimals: 18,
        chainId: 11155111,
        logoURI: 'ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg',
      },
      {
        name: 'Usdt',
        address: '0xaA8E23Fb1079EA71e0a56F48a2aA51851D8433D0',
        symbol: 'USDT',
        decimals: 6,
        chainId: 11155111,
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
      },
      {
        name: 'Wrapped Ether',
        address: '0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14',
        symbol: 'WETH',
        decimals: 18,
        chainId: 11155111,
        logoURI:
          'https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2/logo.png',
      },
      {
        chainId: 1,
        address: '0x39AA39c021dfbaE8faC545936693aC917d5E7563',
        name: 'Compound USD Coin',
        symbol: 'cUSDC',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_usdc.svg',
      },
      {
        chainId: 1,
        address: '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643',
        name: 'Compound Dai',
        symbol: 'cDAI',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_dai.svg',
      },
      {
        chainId: 1,
        address: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        name: 'Dai Stablecoin',
        symbol: 'DAI',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_DAI.svg',
      },
      {
        chainId: 1,
        address: '0x89d24A6b4CcB1B6fAA2625fE562bDD9a23260359',
        name: 'Sai Stablecoin v1.0',
        symbol: 'SAI',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_SAI.svg',
      },
      {
        chainId: 1,
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
        name: 'Tether USD',
        symbol: 'USDT',
        decimals: 6,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_USDT.svg',
      },
      {
        chainId: 1,
        address: '0xc00e94Cb662C3520282E6f5717214004A7f26888',
        name: 'Compound',
        symbol: 'COMP',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_COMP.svg',
      },
      {
        chainId: 1,
        address: '0x70e36f6BF80a52b3B46b3aF8e106CC0ed743E8e4',
        name: 'Compound Collateral',
        symbol: 'cCOMP',
        decimals: 8,
      },
      {
        chainId: 1,
        address: '0xf650C3d88D12dB855b8bf7D11Be6C55A4e07dCC9',
        name: 'Compound USDT',
        symbol: 'cUSDT',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_usdt.svg',
      },
      {
        chainId: 1,
        address: '0x6C8c6b02E7b2BE14d4fA6022Dfd6d75921D90E4E',
        name: 'Compound Basic Attention Token',
        symbol: 'cBAT',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_bat.svg',
      },
      {
        chainId: 1,
        address: '0x0D8775F648430679A709E98d2b0Cb6250d2887EF',
        name: 'Basic Attention Token',
        symbol: 'BAT',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_BAT.svg',
      },
      {
        chainId: 1,
        address: '0x4Ddc2D193948926D02f9B1fE9e1daa0718270ED5',
        name: 'Compound Ether',
        symbol: 'cETH',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_eth.svg',
      },
      {
        chainId: 1,
        address: '0xF5DCe57282A584D2746FaF1593d3121Fcac444dC',
        name: 'Compound Sai',
        symbol: 'cSAI',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_sai.svg',
      },
      {
        chainId: 1,
        address: '0x158079Ee67Fce2f58472A96584A73C7Ab9AC95c1',
        name: 'Compound Augur',
        symbol: 'cREP',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_rep.svg',
      },
      {
        chainId: 1,
        address: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
        name: 'Wrapped BTC',
        symbol: 'WBTC',
        decimals: 8,
      },
      {
        chainId: 1,
        address: '0x1985365e9f78359a9B6AD760e32412f4a445E862',
        name: 'Reputation',
        symbol: 'REP',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_REP.svg',
      },
      {
        chainId: 1,
        address: '0xB3319f5D18Bc0D84dD1b4825Dcde5d5f7266d407',
        name: 'Compound 0x',
        symbol: 'cZRX',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_zrx.svg',
      },
      {
        chainId: 1,
        address: '0xC11b1268C1A384e55C48c2391d8d480264A3A7F4',
        name: 'Compound Wrapped BTC',
        symbol: 'cWBTC',
        decimals: 8,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/ctoken_wbtc.svg',
      },
      {
        chainId: 1,
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        name: 'USD Coin USDC',
        symbol: 'USDC',
        decimals: 6,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_USDC.svg',
      },
      {
        chainId: 1,
        address: '0xdd974D5C2e2928deA5F71b9825b8b646686BD200',
        name: 'Kyber Network Crystal',
        symbol: 'KNC',
        decimals: 18,
      },
      {
        chainId: 1,
        address: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
        name: 'ChainLink Token',
        symbol: 'LINK',
        decimals: 18,
      },
      {
        chainId: 1,
        address: '0xFAce851a4921ce59e912d19329929CE6da6EB0c7',
        name: 'Compound ChainLink',
        symbol: 'cLINK',
        decimals: 8,
      },
      {
        chainId: 1,
        address: '0x0cec1a9154ff802e7934fc916ed7ca50bde6844e',
        name: 'PoolTogether Governance Token',
        symbol: 'POOL',
        decimals: 18,
        logoURI: 'https://raw.githubusercontent.com/compound-finance/token-list/master/assets/asset_POOL.svg',
      },
      {
        chainId: 1,
        address: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
        name: 'Uniswap',
        symbol: 'UNI',
        decimals: 18,
        logoURI: 'ipfs://QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg',
      },
      {
        chainId: 1,
        address: '0x35A18000230DA775CAc24873d00Ff85BccdeD550',
        name: 'Compound Uniswap',
        symbol: 'cUNI',
        decimals: 8,
      },
      {
        chainId: 1,
        address: '0x0000000000085d4780B73119b644AE5ecd22b376',
        name: 'TrueUSD',
        symbol: 'TUSD',
        decimals: 18,
      },
      {
        chainId: 1,
        address: '0x12392F67bdf24faE0AF363c24aC620a2f67DAd86',
        name: 'Compound TrueUSD',
        symbol: 'cTUSD',
        decimals: 8,
      },
    ],
    version: {
      major: 2,
      minor: 0,
      patch: 0,
    },
  },
  pendingUpdate: null,
  loadingRequestId: null,
  error: null,
};
